import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';

import {orderIdApiResponse, orderIdRequest} from '../lib/types';
import {ordersmsApiCall} from '../api/ordersms.api';
//import axios from 'axios';

const ordersmsData = {
  resultCode: '',
  resultMessage: '',
};

interface posState {
  smsorderApiResponse: orderIdApiResponse;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: posState = {
  smsorderApiResponse: ordersmsData,
  loading: false,
  error: '',
};

export const smsorderIdBySms = createAsyncThunk(
  'employee/ordersms',
  async (parameters: orderIdRequest, thunkApi) => {
    return ordersmsApiCall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const ordersmsSlice = createSlice({
  name: 'ordersmsSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetOrderSmsState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(smsorderIdBySms.pending, state => {
      state.loading = true;
    });
    builder.addCase(smsorderIdBySms.fulfilled, (state, action) => {
      state.loading = false;
      state.smsorderApiResponse = action.payload;
    });
    builder.addCase(smsorderIdBySms.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetOrderSmsState} = ordersmsSlice.actions;

export const ordersmsApiResponse = (state: RootState): orderIdApiResponse =>
  state.ordersmsReducer.smsorderApiResponse;
export const errorInOrderSmsApi = (state: RootState): string =>
  state.ordersmsReducer.error;
export const orderSmsLoading = (state: RootState): boolean =>
  state.ordersmsReducer.loading;

export default ordersmsSlice.reducer;
